import { render, staticRenderFns } from "./AIAvatarSelectionButton.vue?vue&type=template&id=0e37cff4"
import script from "./AIAvatarSelectionButton.vue?vue&type=script&lang=ts"
export * from "./AIAvatarSelectionButton.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarSelectionButton.vue?vue&type=style&index=0&id=0e37cff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports